import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { taskTree_template } from "../components/templates/taskTree_template";

declare var ko: any;
declare var page: any;

export class taskTree extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    private brandXHR: XMLHttpRequestHandler;
    protected elementsList: taskTree_template;

    protected getModuleName(): string {
        return "taskTree";
    }

    /**
     * Build the DOM elements for this module
     */
    public buildContent(): Array<Element> {
        this.elementsList = new taskTree_template("tree", this.viewModel, this);
        return [this.elementsList.build()];
    }

    /**
     * Called when the page is first displayed
     */
    public fillPage(): void {
        this.getFormData();
        this.refreshTree();
    }

    protected getFormData() {

        let validateReq_url: string = '/api/visualTask/references/';
        let validateReq_params: Array<Array<string>> = [];

        this.brandXHR = new XMLHttpRequestHandler(validateReq_url, validateReq_params, this);

        this.brandXHR.onReadyStateFunction = this.onGetFormDataReturn;
        this.brandXHR.execute();
    }

    protected onGetFormDataReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let brands = [{ id: 'SR', name: "ScreenRant"}];

                for (let brand of responseParsed.brands) {
                    brands.push({id: brand.shortName, name: brand.name});
                }

                obj.elementsList.brandFilter.setOptions(brands);
                obj.elementsList.brandFilter.setLabel("Brand");

            });
        }
    }



    /**
     * Fetch the task-tree JSON from the API
     */
    protected refreshTree(): void {
        // show loading indicator
        this.loadingIn(this.elementsList.builtTemplate);

        // cancel any pending request
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        const taslTree_url = '/api/visualTask/';
        let taskTree_params: Array<Array<string>> = [];
        taskTree_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(taslTree_url,taskTree_params, this);

        const requestId = this.XHRHdl.requestId;
        setTimeout(() => {
            if (requestId === this.XHRHdl.requestId) {
                this.XHRHdl.onReadyStateFunction = this.onGetTreeDataReturn;
                this.XHRHdl.execute();
            }
        }, 100);
    }

    /** Called by the brand dropdown when the user picks a new brand */
    protected filterDropdownOnChange(): void {
        // re-draw the tree using the newly selected brand
        this.refreshTree();
    }

    /**
     * Handle API response and populate the tree
     */
    protected onGetTreeDataReturn = (req: any, obj: any) => {
        return () => {
            obj.manageResponse(req, obj, () => {
                const responseParsed = JSON.parse(req.request.response);
                obj.elementsList.setTasks(responseParsed);
            });

            if (req.request.readyState === 4) {
                // hide loading indicator
                obj.loadingOut(obj.elementsList.builtTemplate);
            }
        };
    };
}



// WEBPACK FOOTER //
// ./js/modules/taskTree.ts